// eslint-disable-next-line no-unused-vars
import React from "react";
import DashboardLayout from "../Shared/DashboardLayout";
import InventoryDetailTable from "../components/InventoryDetailTable";

const InventoryPage = () => {
  return (
    <DashboardLayout>
      <InventoryDetailTable />
    </DashboardLayout>
  );
};

export default InventoryPage;
